module.exports = __webpack_public_path__ + "assets/img/sdwan-module1-5.49b8330d.png";